// extracted by mini-css-extract-plugin
module.exports = {"root":"Table_root__2ILg8","head":"Table_head__3Mj6Y","col":"Table_col__3srEJ"};